import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { EmitterService } from '../services/emitter.service';
import { UserDetailsService } from '../services/user-details.service';
import { environment } from "../../environments/environment";
import { PaymentService } from '../services/payment.service';
import * as $ from 'jquery';
import { Utility } from '../shared/utility/utility';
import { Subject } from 'rxjs/internal/Subject';
@Component({
  selector: 'app-crypto-cashier',
  templateUrl: './crypto-cashier.component.html',
  styleUrls: ['./crypto-cashier.component.scss']
})
export class CryptoCashierComponent implements OnInit, OnDestroy, AfterViewInit {

  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  startedDeposit = false;
  userDetail;
  windowType;
  showCustomAmmountSelection = true;
  userCurrencySymbol = '';
  langCode = localStorage.getItem('langCode');
  valueOne = "50";
  valueTwo = "250";
  valueThree = "500";
  customAmount:string = this.valueTwo
  multipleValue = 1;
  isNorway = false;
  userCountry;
  needToShowDepositWIthBankId = false;
  isCurrencyDefaultPosition = true;
  destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('inputRef', { static: false }) inputRef: any;
  constructor(public userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    private paymentService: PaymentService, private utility:Utility) {
    this.isCurrencyDefaultPosition = this.userDetailsService.userCurrencyInfo?.position == 'after' ? false : true;
    this.emitterService.broadCastBuyCryptoPayment(this.customAmount)
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    })
    this.emitterService.triggerMoonpayDeposite$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.moonpayDeposit();
    })
  }

  @ViewChild('hiddenText') textEl: ElementRef;

  minWidth: number = 40;
  width: number = this.minWidth;
  currentKeyCode
  updateKeyCode(event){
    this.currentKeyCode = event.keyCode;
  }

  checkMaxValue(e) {
    let value = $("#inputAmount")[0].innerText;
    if (value.indexOf(".") == 0 || value.indexOf("0") == 0) {
      $("#inputAmount")[0].innerText = this.customAmount;
      return;
    }
    if (typeof value == "string") {
      value = parseFloat(value);
      this.customAmount = value;
    } else {
      this.customAmount = value;
    }

    if (typeof value == "string") {
      value = parseFloat(value);
    }
    if (
      (value >= 15000 && !this.isNorway) ||
      (this.isNorway && value >= 150000)
    ) {
      if (!this.isNorway) {
        value = "15000";
      } else {
        value = "150000";
      }
      this.customAmount = value;
      $("#inputAmount")[0].innerText = this.customAmount;
      this.setCaretToEnd(e.target);
    } 
    this.emitterService.broadCastBuyCryptoPayment(this.customAmount)
  }
  setCaretToEnd(event){
    this.utility.setCaretToEnd(event);
  }
  customAmountSet(event,value) {
    this.customAmount = value;
    $("#inputAmount")[0].innerText = this.customAmount;
    this.setFocusToCustomInput(event);
    this.emitterService.broadCastBuyCryptoPayment(this.customAmount)
  }
  getWindowType() {
    var ww = document.body.clientWidth;
    if (ww >= 1024) {
      this.windowType = 'device';
    } else {
      this.windowType = 'mobile';
    }
  }
  ngAfterViewInit(): void {
    this.customAmountSet(this.inputRef.nativeElement, this.valueTwo);
    setTimeout(() => {
      let focusInput = document.getElementById("inputAmount");
      if (focusInput && this.windowType == 'device') {
        focusInput.focus();
      }
    }, 1000);
  }
  ngOnInit() {
    this.getWindowType();
    this.userDetail = this.userDetailsService.getUserProfileDetails();
    this.userCurrencySymbol = this.userDetailsService.getUserCurrencyDetails().symbol

    this.userCountry = this.userDetailsService.userProfileDetails && this.userDetailsService.userProfileDetails.country ? this.userDetailsService.userProfileDetails.country : "";
    if(this.userCountry){
        this.needToShowDepositWIthBankId = environment.xSaleBuumiCountries.indexOf(this.userCountry) >=0 ? true : false;
    }
    if(this.userDetail.country && this.userDetail.country.toLowerCase() == 'no'){
      this.isNorway = true;
      this.multipleValue = 10;
      let amount:any = this.customAmount;
      this.customAmount = (amount * 10).toString();
    } else {
      this.isNorway = false;
      this.multipleValue = 1;
    }
  }

  moonpayDeposit() {
    let sampleData = {
      "depositAmount": this.customAmount,
      "paymentMethod": "MOONPAY",
      "txnType": "deposit-cashier",
      "emailAddress": this.userDetail["email"],
      "cryptoDetails": JSON.stringify({ "option": environment.currencyForMoonpay[0] })
    }

    this.paymentService.depositeProcess(sampleData).then((response: any) => {
      if (response.status == 'SUCCESS') {
        this.emitterService.broadCastShowMoonpayPending(true);
        let a = document.createElement('a');
        a.target = '_blank';
        a.href = response.gatewayRequest.redirect_url;
        a.click();
        this.showCustomAmmountSelection = false;
        // this.updateMoonpayPayment(response.gatewayRequest.redirect_url)
      }
    })
  }

  updateMoonpayPayment(src) {
    let iframe = `<iframe width='100%' height='750' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src=${src}></iframe>`;
    $("#moonpay-cashier").html(iframe);
  }
  setFocusToCustomInput(e) {
   this.setCaretToEnd(e)
  }
  showCaret(event: FocusEvent) {
    event.preventDefault();  
    event.stopPropagation();
    // This function can be used to show the caret when the user focuses on the input field
    const inputElement = event.target as HTMLElement;
    inputElement.style.caretColor = 'black'; // or any color you prefer
}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
